import React from 'react';
import { useSelector } from 'react-redux';

// Components
import WarningMessage from 'components/WarningMessage';

// Selectors
import { selectReEntryWarning } from 'services/reEntryWarning/selectors';

export default function ReEntryPeriodDaysWarning(): React.ReactElement | null {
    const isWarning = useSelector(selectReEntryWarning);

    return (
        <WarningMessage
            title="Warning"
            content="This job falls within the re-entry period of an existing spray, PPE must be worn when entering recently sprayed areas"
            visible={isWarning}
            style={{ margin: '24px 0' }}
        />
    );
}
